var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "muli-tags",
      attrs: { id: "muli-tags" },
      on: { click: _vm.focus }
    },
    [
      _vm.title
        ? _c("div", { staticClass: "textTitle" }, [_vm._v(_vm._s(_vm.title))])
        : _vm._e(),
      _vm._v(" "),
      _vm.tags.length < 1 && !_vm.textbgShow
        ? _c("div", { staticClass: "textbg" }, [_vm._v(_vm._s(_vm.message))])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.tags, function(tag, index) {
        return _c(
          "button",
          { key: index, staticClass: "btn", attrs: { title: tag } },
          [
            _vm._v(_vm._s(tag) + " "),
            _c(
              "span",
              {
                staticClass: "close-icon",
                on: {
                  click: function($event) {
                    return _vm.delTag(index)
                  }
                }
              },
              [_c("span", { staticClass: "close-font" })]
            )
          ]
        )
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.current,
            expression: "current"
          },
          { name: "clearEmoji", rawName: "v-clearEmoji" }
        ],
        ref: "input",
        attrs: { type: "text", autocomplete: "off" },
        domProps: { value: _vm.current },
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.add($event)
          },
          keydown: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "space", 32, $event.key, [
                  " ",
                  "Spacebar"
                ])
              ) {
                return null
              }
              return _vm.split($event)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
                  "Backspace",
                  "Delete",
                  "Del"
                ])
              ) {
                return null
              }
              return _vm.del($event)
            },
            function($event) {
              if (!$event.type.indexOf("key") && $event.keyCode !== 188) {
                return null
              }
              return _vm.split($event)
            }
          ],
          blur: _vm.endTextbg,
          focus: _vm.showTextbg,
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.current = $event.target.value
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-785d01ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-785d01ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/input/tag_input_common.vue
// module id = null
// module chunks = 